/**
 * Calcule l'âge d'un animal avec affichage adapté
 * Si le mouton est mort, l'âge est figé à la date de décès
 * @param {string} dateNaissance - Date de naissance au format ISO
 * @param {string} dateDeces - Date de décès au format ISO (optionnel)
 * @returns {string} - Age formaté (ex: "3 mois" ou "2 an(s)")
 */
export const calculateAge = (dateNaissance, dateDeces) => {
  if (!dateNaissance) return 'Inconnu';
  
  const endDate = dateDeces ? new Date(dateDeces) : new Date();
  const birthDate = new Date(dateNaissance);
  
  const diffTime = endDate - birthDate;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  const diffMonths = Math.floor(diffDays / 30.44);
  const diffYears = Math.floor(diffDays / 365.25);
  
  if (diffMonths < 12) {
    return diffMonths === 0 ? '< 1 mois' : `${diffMonths} mois`;
  } else {
    return diffYears === 1 ? '1 an' : `${diffYears} ans`;
  }
};

/**
 * Calcule l'âge avec plus de détails pour les tooltips
 * Si le mouton est mort, l'âge est figé à la date de décès
 * @param {string} dateNaissance - Date de naissance au format ISO
 * @param {string} dateDeces - Date de décès au format ISO (optionnel)
 * @returns {object} - Objet avec détails de l'âge
 */
export const getAgeDetails = (dateNaissance, dateDeces) => {
  if (!dateNaissance) return { display: 'Inconnu', tooltip: '' };
  
  const endDate = dateDeces ? new Date(dateDeces) : new Date();
  const birthDate = new Date(dateNaissance);
  
  const diffTime = endDate - birthDate;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  const diffMonths = Math.floor(diffDays / 30.44);
  const diffYears = Math.floor(diffDays / 365.25);
  
  let display, tooltip;
  const suffix = dateDeces ? ' (au décès)' : '';
  
  if (diffMonths < 12) {
    display = diffMonths === 0 ? '< 1 mois' : `${diffMonths} mois`;
    tooltip = `${diffDays} jour(s) - Né(e) le ${birthDate.toLocaleDateString('fr-FR')}${dateDeces ? ` - Décédé(e) le ${endDate.toLocaleDateString('fr-FR')}` : ''}`;
  } else {
    display = diffYears === 1 ? '1 an' : `${diffYears} ans`;
    const remainingMonths = diffMonths - (diffYears * 12);
    tooltip = `${diffYears} an(s) et ${remainingMonths} mois - Né(e) le ${birthDate.toLocaleDateString('fr-FR')}${dateDeces ? ` - Décédé(e) le ${endDate.toLocaleDateString('fr-FR')}` : ''}`;
  }
  
  display += suffix;
  
  return { display, tooltip };
};
